// Analyze/src/components/LoadingScreen.js
import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAnchor } from "@fortawesome/free-solid-svg-icons";
import "../styles/LoadingScreen.css";

const LoadingScreen = ({ message = "Preparing the Pirates Guild..." }) => {
  const [backgroundImage, setBackgroundImage] = useState("");
  const [fadeIn, setFadeIn] = useState(false);

  useEffect(() => {
    const backgroundImages = [
      "compass 03.png",
      "Pirate ship 01.png",
      "Pirate ship 02.png",
      "Pirate ship 03.png",
      "Pirate's map 02.png",
      "Pirates Guild 02.png",
      "Pirates Guild 04.png",
      "treasure chest 01.png",
    ];
    const randomIndex = Math.floor(Math.random() * backgroundImages.length);
    const selectedImage = backgroundImages[randomIndex];
    const encodedImage = encodeURIComponent(selectedImage);
    setBackgroundImage(`/assets/${encodedImage}`);

    setTimeout(() => {
      setFadeIn(true);
    }, 100);
  }, []);

  return (
    <div className="loading-screen">
      {backgroundImage && (
        <div
          className={`loading-background ${fadeIn ? "fade-in" : ""}`}
          style={{ backgroundImage: `url(${backgroundImage})` }}
        />
      )}
      <div className="loading-content">
        <div className="loading-message">{message}</div>
        <FontAwesomeIcon icon={faAnchor} spin className="loading-spinner" />
      </div>
    </div>
  );
};

export default LoadingScreen;
